import identity from "lodash/identity"
import { Field } from "react-final-form"
import InputMask from "react-input-mask"

import {
  composeValidators,
  mustBeValidBirthday,
  required,
} from "@trueskin-web/functions"
import { useTranslation } from "@trueskin-web/translations"

import InputControl from "./input-control"

const BirthDate = () => {
  const { t } = useTranslation()

  return (
    <Field
      data-testid="web-portal-shipping-form-birth-date"
      name="birthDate"
      component={InputControl}
      as={InputMask}
      mask="99.99.9999"
      maskPlaceholder=""
      required
      validate={composeValidators(
        (value) => required(value, t("Generic.errors.birthDateRequired")),
        mustBeValidBirthday
      )}
      parse={identity}
      label={t("Start.Shipping.birthDate")}
      placeholder="TT.MM.JJJJ"
      message={t("Start.Shipping.birthDateHint")}
      sx={{
        "& input::placeholder": {
          transition: "opacity 0.2s ease",
        },
        "& input:focus::placeholder": {
          opacity: 1,
        },
      }}
    />
  )
}

export default BirthDate
